import { StyledFormHelperText } from './index.styles';

const CustomFormError = ({ errorText }: { errorText: string }) => {
  return <StyledFormHelperText>{errorText}</StyledFormHelperText>;
};

export default CustomFormError;
